angular.module('SpidApp')

.controller('ParamsController',
        ['$scope', '$state', '$timeout', 'User', 'UserService', 'Toaster',
function ($scope,   $state,   $timeout,   User,   UserService,   Toaster) {
    
    $scope.tabs = [
         { titre: "Gestion de l'agence",      route: 'app.parameters.agency',   role: [ User.RECEVEUR ] }
       , { titre: "Gestion des agences",      route: 'app.parameters.agency',   role: [ User.SUPERVISEUR ] }
       , { titre: "Gestion de la devise",     route: 'app.parameters.currency', role: [ User.RECEVEUR ] }
       , { titre: "Gestion des utilisateurs", route: 'app.parameters.users',    role: [ User.RECEVEUR, User.SUPERVISEUR ] }
    ];	
    
    $scope.GUICHETIER = User.GUICHETIER
    $scope.RECEVEUR   = User.RECEVEUR
    
    var tabsActivation = function() {
	    $scope.tabs.forEach(function(item){
	    	item.active = $state.includes(item.route);
	    	
	    	item.show = false;
	    	if (item.role && item.role.lastIndexOf($scope.user.activeRole) !== -1) {
	    		item.show = true;
	    	}
	    });
    }
    
    $scope.$on('changeRoleEvent', function() {
    	var item = _getActiveTab();

        if (item.role && item.role.lastIndexOf($scope.user.activeRole) === -1) {
        	$state.go('app.parameters.agency');
    	}
        $timeout(function() {
        	 tabsActivation();
        }, 75);
    });
    
    tabsActivation();
    
    var _getActiveTab = function() {
    	var _item = null;
    	$scope.tabs.forEach(function(item){
    		if (item.active) {
    			_item = item;
    		}
	    });
    	return _item;
    }
    
    $scope.expirePassword = function (email) {
       if (!email) {
          return
       }
       
       UserService.expirePassword(email).then(function () {
          Toaster.show('Mot de passe réinitialisé');
       });
    }
}])
